module.exports = __webpack_public_path__ + "img/social-media-display-toyota.047796df.png";